
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { CityListItem } from "./CityListItem";
import { City, Organization } from "@/types/flight";

interface CityListProps {
  cities: City[];
  organizations: Organization[];
  onEdit: () => void;
  onDelete: (id: string) => void;
}

export function CityList({ cities, organizations, onEdit, onDelete }: CityListProps) {
  // Group cities alphabetically by first letter
  const groupedCities = cities.reduce((acc, city) => {
    const firstLetter = city.name.charAt(0).toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(city);
    return acc;
  }, {} as Record<string, City[]>);

  // Sort letters alphabetically
  const sortedLetters = Object.keys(groupedCities).sort();

  return (
    <div className="border rounded-lg">
      <Accordion type="multiple" className="w-full">
        {sortedLetters.map((letter) => (
          <AccordionItem key={letter} value={letter}>
            <AccordionTrigger className="px-4 py-3 text-left">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-lg">{letter}</span>
                <Badge variant="secondary" className="ml-2">
                  {groupedCities[letter].length} cities
                </Badge>
              </div>
            </AccordionTrigger>
            <AccordionContent className="px-4 pb-3">
              <div className="space-y-2">
                {groupedCities[letter]
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((city) => (
                    <CityListItem
                      key={city.id}
                      city={city}
                      organizations={organizations}
                      onEdit={onEdit}
                      onDelete={onDelete}
                    />
                  ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
